export enum EnumPeriodicidad {
  MENSUAL = 1,
  QUINCENAL = 2,
  SEMANAL = 3,
  DIARIA = 4,
}

export enum EnumCapturarPor {
  CANTIDADES,
  PORCENTAJES,
}

export enum EnumFilters {
  ALL= 'ALL',
  PARTIDAS= 'PARTIDAS',
  PARTIDASSINNIVEL= 'PARTIDASSINNIVEL',
  CONCEPTOS= 'CONCEPTOS',
  UNAPARTIDA= 'UNAPARTIDA',
  UNCONCEPTO= 'UNCONCEPTO',
  UNRESPONSABLE= 'UNRESPONSABLE',
}

export enum EnumAccionBotones {
  NUEVOPROGRAMA = 'NUEVOPROGRAMA',
  CANCELARNUEVOPRORAMA = 'CANCELARNUEVOPRORAMA',
  EDITARPROGRAMA = 'EDITARPROGRAMA',
  BORRARPROGRAMA = 'BORRARPROGRAMA',
}

export enum EnumVistaPrograma {
  PERIODOS = 'MENSAJES.GRALS.PO_PERIODOS',
  MONTOS = 'MENSAJES.GRALS.PO_MONTOS',
  GRAFICA = 'MENSAJES.GRALS.PO_GRAFICA',
}

export enum EnumDesdeDondeGenerarRespaldo {
  CATALOGOPPTOGRAL = 'CATALOGOPPTOGRAL',
  PRINCIPAL = 'PRINCIPAL',
}

export enum EnumVerConceptos {
  TODOS = 'MENSAJES.GRALS.TODOS',
  CONPORCENTAJEMENORCIEN = 'MENSAJES.GRALS.PO_CON_PORCENTAJE_MENOR_CIEN',
  CONPORCENTAJEIGUALRCIEN = 'MENSAJES.GRALS.PO_CON_PORCENTAJE_IGUAL_CIEN',
  CONPORCENTAJEMAYORCIEN = 'MENSAJES.GRALS.PO_CON_PORCENTAJE_MAYOR_CIEN',
}
